import React from "react";

import FormField from "./formField.js";
import  sAction  from "sAction";
import InputText from "../formElements/InputText";

import Tooltip from '@material-ui/core/Tooltip';
import CustomTooltip from "ROOT/src/components/customTooltip/CustomTooltip";

export default class DefaultInputField extends FormField {
  constructor() {
    super();
    this.state = {
      state: "fine",
    };
    this.input = React.createRef();
  }
  componentDidMount() {
    super.componentDidMount();
    const newRecord = this.props.newRecord;
    if (!newRecord) {
      //    this.refs.input.focus();
      //  this.refs.input.select();
    }
    this.defaultValue = this.getValue();
    if( this.state.ok !== false) {
      sAction.dataSet(this.props.way+'/def/error', false);
      }
  }
  getValue() {
    //return "";
    return this.input.current.value;
  }
  save(param = {}) {
    const value = this.getValue();
    if (this.check()) {
      const data = {
          way: this.props.way,
          name: this.props.data.name,
          value,
          ...param
      }
      this.saveField(data);
    }
  }
  saveField(data) {
    sAction.saveField(data);
  }
  check() {
    var required = this.props.data.def.get("required");
    if (required === undefined) {
      required = false;
    }
    const reg = this.state.reg;
    const value = this.getValue();
    var ok = true;

    if (required === true && (value === "" || value === null)) {
      ok = false;
      this.setState({ ok: ok });
    } else if (required === true && value != "") {
      if (reg != undefined && !reg.test(value)) {
        ok = false;
        this.setState({ ok: ok });
      }
    } else if (required === false && value != "") {
      if (reg != undefined && !reg.test(value)) {
        ok = false;
        this.setState({ ok: ok });
      }
    }
    if (ok === false) {
      sAction.dataSet(this.props.way+'/def/error',(sAction.translate("LBL_WRONG_VALUE")));
      this.lockRecord();
    }
    return ok;
  }
  lockRecord() {
    sAction.dataSet(this.props.prefix + "/canSave", false);
  }
  cancel() {
    sAction.dataSet(this.props.way + "/actEdit", false);
    sAction.dataSet(this.props.way+'/def/error', false);
  }
  onBlur(e) {
    const relTarget = e.relatedTarget;
    if (relTarget == null) {
      this.save();
    } else {
      var parent = relTarget.closest(
        "div[data-fieldname='" + this.props.data.name + "']"
      );
      if (parent == null) {
        this.save();
      }
    }
  }
  keyUpCall(e) {
    const keyCode = e.keyCode;
    if (keyCode == 13 && e.ctrlKey === false) {
      this.save();
    } else if (keyCode == 27) {
      this.cancel();
    }
  }
  render() {
    const data = this.props.data;
    const newRecord = this.props.newRecord;
    const ok = this.state.ok;
    var containerClass = "inputEditContainer";
    var error = false;
    if (ok === false) {
      //  inputClass += " wrongInput";
      error = true;
    }
    var errorValue =  this.props.data.def.get("error");
    var value = data.value;
    if (newRecord && (value == "" || value == undefined)) {
      value = "";
    }
    else{
      value = sAction.decodeHTMLEntities(value);
    }

    return (
      <div className={containerClass} data-fieldname={data.name}>
        <div className="inputContainer">
          <InputText
            autoFocus={true}
            onKeyUp={e => this.keyUpCall(e)}
            onKeyDown={e => this.onKeyDown(e)}
            myRef={this.input}
            inputProps={{maxLength: this.props.data.def.get("len")}}
            onBlur={e => this.onBlur(e)}
            error={error}
            defaultValue={value}
            id={data.name}
            name={data.name}
            fieldtype={data.def.get("type")}
          />
        </div>

        {errorValue && (
            <CustomTooltip
                extraClass={"tooltipAlignRight"}
                customStyle={{
                    backgroundColor: "red",
                    transform: "translateX(-103%)",
                    bottom: "calc(calc(var(--tooltip-margin) * -1) + 10px)",
                }}
                direction={"bottom"}
                content={errorValue}
            />
        )}
        {!newRecord && (
          <div className="buttonContainer">
             {errorValue &&
              (
                <div
                tabIndex="-1"
                className="warningMessage inputEditButton"
                >
                  <div className={"icon-warning"}></div>
                </div>
              )}

            <div
              tabIndex="2"
              onClick={() => this.save()}
              className="inputEditButton"
            >
              <div className={"icon-detailConfrim"} /> 
            </div>
            <div
              tabIndex="3"
              onClick={() => this.cancel()}
              className=" inputEditButton"
            >
              <div className={"icon-detailCancel"} />
            </div>
          </div>
        )}
      </div>
    );
  }
}
